import styled from "styled-components";
import {COLOR} from "src/service/constant/color";
import {customMedia} from "src/styles/common/common";

const UserPageMainWrap = styled.div`
  display: block;
`
const UserPageMainPNumber = styled.h4`
  font-family: NotoSansBold, sans-serif;
  font-size: 36px;
  line-height: 52px;
  text-align: center;
  display: block;
  margin: 40px auto 25px auto;

  &:before {
    display: block;
    content: "가입번호";
    font-size: 16px;
    line-height: 23px;
    color: ${COLOR.point1};
  }

  ${customMedia.lessThan('tablet')`
    margin: 24px auto 12px auto;
    font-size: 24px;
    line-height: 35px;
    &:before {
        font-size: 14px;    
    }
  `}
`
const UserPageInfo = styled.div`
  border-top: 1px solid ${COLOR.blueGray2};
  border-bottom: 1px solid ${COLOR.blueGray2};
  margin: 25px auto 44px auto;
  height: 256px;
  display: flex;
  ${customMedia.lessThan('tablet')`
     border-bottom: unset;
     height: unset;
     margin: 25px auto;
     display: grid;
     grid-template-rows: 1fr 1fr;
     grid-template-columns: 1fr 1fr;
     flex-wrap:wrap;
  `}
`

const UserPageIconBox = styled.section<{ border: boolean, lineMarginTop?: string }>`
  margin: 33px auto 44px auto;
  box-sizing: border-box;
  width: 275px;
  height: 169px;
  display: block;
  text-align: center;
  border-right: ${(props) => props.border && `1px solid ${COLOR.blueGray2}`};

  ${customMedia.lessThan('tablet')`
    display: block;
    margin: 0 auto;
    height: 164px;
    width: 300px;
    border-bottom: 1px solid ${COLOR.blueGray2};
  `}
  ${customMedia.lessThan('tablet_cut_line')`
     max-width: 284px;
     width: 100%;
  `}
  > button {
    width: 220px;
    height: 48px;
    border: 1px solid ${COLOR.point1};
    border-radius: 40px;
    padding: 0;
    background: white;
    margin-top: 12px;

    &:active, &:hover {
      -webkit-tap-highlight-color: transparent;
      background-color: ${COLOR.point4};
    }

    > a {
      display: inline-block;
      width: 100%;
      height: 48px;
      font-family: NanumSquareNeoHeavy, sans-serif;
      color: ${COLOR.point1};
      font-size: 18px;
      line-height: 48px;
    }

    ${customMedia.lessThan('tablet')`
        margin-top : unset;
        width: 140px;
        height: 36px;
        > a { 
            height: 36px;
            font-family: NanumSquareNeoHeavy,sans-serif;
            font-size: 14px;
            line-height: 36px;
        }
    `}
  }

  > img {
    display: flex;
    width: 112px;
    height: 112px;
    margin: 0 auto;
    ${customMedia.lessThan('tablet')` 
    width: 60px;
    height: 60px;
    margin-top: 20px;
`}
  }

  > p {
    text-align: center;
    font-family: NanumSquareNeoHeavy, sans-serif;
    font-size: 18px;
    line-height: 20px;
    margin: 4px auto 8px auto;
    ${customMedia.lessThan('tablet')` 
    font-size: 14px;
    line-height: 15px;
    margin: 8px auto;
`}
  }

  > span {
    display: inline-block;
    font-family: NotoSansMedium, sans-serif;
    font-size: 20px;
    line-height: 29px;
    color: ${COLOR.point1};
    ${customMedia.lessThan('tablet')` 
     font-size: 14px;
     line-height: 20px;
    `}
  }
`

const UserPageContents = styled.div`
  display: flex;
  height: 552px;
  gap: 20px;
  margin-bottom: 240px;
  ${customMedia.lessThan('tablet')` 
      height: 304px;
      gap: 16px;
      margin-bottom:277px;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
     display: block; 
     padding-top:24px;
     margin-bottom: 580px;
  `}
`
const UserPageDirectNavItem = styled.div<{ bgColor: string }>`
  width: 540px;
  border-radius: 24px;
  background: ${(props) => props.bgColor};
  display: block;
  cursor: pointer;

  ${customMedia.lessThan('tablet')` 
       margin-top: 25px;
       width:292px;
       height: 303px;
       border-radius: 21px;  
   `}
  ${customMedia.lessThan('tablet_cut_line')`
      margin: 0 auto 16px auto;
      width: 328px;
      height: 340px; 
      display: block;
   `}
  > h4 {
    width: 100%;
    max-width: 286px;
    height: 144px;
    margin: 54px 0 8px 40px;
    font-family: NanumSquareNeoHeavy, sans-serif;
    font-size: 54px;
    line-height: 72px;
    color: white;
    ${customMedia.lessThan('tablet')` 
     font-size: 28px;
     line-height: 36px;
     width: 100%;
     max-width: 152px;
     height: 72px;
     margin: 30px 0 10px 21px;
    `}
    ${customMedia.lessThan('tablet_cut_line')`
       font-size: 32px;
       display: inline-block;
       margin: 36px 0 8px 24px;
       height: 80px;
       max-width: 171px;
       line-height: 40px;
    `}
  }

  > span {
    display: inline-block;
    max-width: 460px;
    font-family: NotoSansRegular, sans-serif;
    font-size: 18px;
    white-space: normal;
    line-height: 26px;
    color: white;
    margin: 0 40px;
    ${customMedia.lessThan('tablet')` 
        max-width: 230px;
        width: 100%;
        font-size: 12px;
        line-height: 18px;
        margin: 0 21px;
     `}
    ${customMedia.lessThan('tablet_cut_line')`
       display: flex;
       max-width: 280px;
       font-size: 14px;
       line-height: 20px;
       margin: 0 24px;
    `}
  }

  > img {
    display: flex;
    margin: 0 auto;
  }

  .letter {
    width: 464px;
    height: 232px;
    margin-top: 88px;
    ${customMedia.lessThan('tablet')` 
        width: 251px;
        height: 127px;
        margin-top: 29px;
     `}
    ${customMedia.lessThan('tablet_cut_line')`
        width: 282px;
        height: 143px;
        margin-top: 33px;
     `}
  }

  .unse {
    width: 332px;
    height: 212px;
    margin-top: 30px;
    ${customMedia.lessThan('tablet')` 
        width: 180px;
        height: 116px;
        margin-top: 24px;
     `}
  }
`

export {
    UserPageMainWrap,
    UserPageMainPNumber,
    UserPageInfo,
    UserPageContents,
    UserPageIconBox,
    UserPageDirectNavItem
}